import en from "./en";
import de from "./de";
import hr from "./hr";
import es from "./es";
import fr from "./fr";
import it from "./it";
import pt from "./pt";
import ru from "./ru";
import zh from "./zh";
import nl from "./nl";
import sl from "./sl";

export default { en, de, hr, es, fr, it, pt, ru, zh, nl, sl };
